<template>
  <section class="module dt-epitasis">
    <template v-if="show">
      <h3>
        剧情
        <template v-if="kvFinishEp && kvFinishEp > 4 && false">
          <span v-if="kvFinishEp >= entity_finish_ep"> 共{{ entity_finish_ep }}集 </span>
          <span v-else>更新至第{{ kvFinishEp }}集</span>
        </template>
      </h3>
      <div class="dt-epitasis-wrap">
        <ul class="dt-epitasis-list">
          <li
            v-for="(v, index) in plot"
            :key="index"
          >
            <a
              v-if="index < 4"
              :href="'/summary/plot?key=' + dockey + '&ep=' + v.ep + '&spver=' + spver"
              :uigs="'epitasis_' + v.ep"
            >
              <p class="tit">{{ showNumbStyle ? '第' + v.ep + '集' : v.title }}</p>
              <p class="con">{{ formatString(v.content) }}</p>
            </a>
          </li>
          <li>
            <a
              v-if="kvFinishEp && kvFinishEp > 4"
              :href="'/summary/plot?key=' + dockey + '&spver=' + spver"
              class="more"
            >更多</a>
          </li>
        </ul>
      </div>
    </template>
  </section>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';

import { getSpver } from '../../common/js/util';

export default {
  data() {
    return {
      io: null,
      show: false,
      plot: [],
      showNumbStyle: false,
      kvFinishEp: 0,
    };
  },
  computed: {
    ...mapState('detail', ['itemData', 'finishEpisode']),
    dockey() {
      return this.itemData.dockey || '';
    },
    spver() {
      return getSpver({ spver: this.$route.query.spver, returnType: 'num' }) || '';
    },
    entity_finish_ep() {
      // 剧集的集数
      return this.finishEpisode;
    },
  },
  mounted() {
    const mDom = document.querySelectorAll('.module.dt-epitasis');
    const self = this;
    if (!this.io) {
      this.io = new IntersectionObserver((entries) => {
        entries.forEach((item) => {
          if (item.isIntersecting) {
            try {
              self.getData();
            } finally {
              self.io.unobserve(item.target);
            }
          }
        });
      });
    }
    for (const md of mDom) {
      this.io.observe(md);
    }
  },
  methods: {
    async get(data) {
      const res = await axios.get('/napi/video/kv', { timeout: 2000, params: data }).catch((e) => {
        console.log('[EPITASIS_AXIOS_ERROR]', e);
      });
      return (res && res.data && res.data.data) || '';
    },
    async getData() {
      const self = this;
      const { dockey } = self;
      const keyList = [];
      const data = [];
      if (dockey && (dockey.startsWith('teleplay_') || dockey.startsWith('film_'))) {
        const p1 = { cat: 'entityplotindex', key: dockey };
        const plotlist = await self.get(p1);
        if (plotlist && plotlist.single_intro_index && plotlist.content && Object.keys(plotlist.content).length > 0) {
          // 有结果则展示剧情模块
          self.show = true;
          const singleIntroIndex = plotlist.single_intro_index.all;
          const titleList = plotlist.content;
          const kvFinishEp = self.getLastFromArray(singleIntroIndex);
          self.kvFinishEp = kvFinishEp;
          // 判断展示数字选集还是文字选集样式(文字内容存在空则展示数字)
          const plotTitles = Object.keys(titleList);
          const regex = RegExp('(^第(.*)集.*|^大结局.*)');
          for (const k of plotTitles) {
            // 最多展示4条剧情信息
            if (keyList.length > 3) break;
            if (titleList[k] === '' || !regex.test(titleList[k])) {
              self.showNumbStyle = true;
            }
            keyList.push(`${dockey}_${k}`);
            data.push({ ep: k, title: titleList[k] });
          }
          // 请求剧情内容
          const p2 = { cat: 'entityplot', keylist: keyList.join(',') };
          const plotConlist = await self.get(p2);
          if (plotConlist && Object.keys(plotConlist).length > 0) {
            const ret = Object.values(plotConlist);

            Object.keys(ret).forEach((i) => {
              data[i].content = ret[i].content;
            });

            self.plot = data;
          } else {
            // 无剧情内容不展示剧情入口
            self.show = false;
          }
        }
      }
    },
    getLastFromArray(array) {
      let result = '';
      if (Array.isArray(array) && array.length > 0) {
        result = [...array].pop();
      }
      return result;
    },
    formatString(str) {
      if (str) {
        return str.replace(/(<p>|<\/p>)/g, '');
      }
      return '';
    },
  },
};
</script>

<style lang="scss">
@import '../../../asset/css/abstracts/mixin.scss';
@import '../../../asset/css/abstracts/function_sprite_detail.scss';

.episode-nostyle {
  padding: 0 14px;
}

.dt-epitasis {
  margin-bottom: 30px;
}

.dt-epitasis-wrap {
  height: 106px;
  overflow: hidden;
}

.dt-epitasis-list {
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
  white-space: nowrap;
  font-size: 0;
  height: 120px;

  li {
    display: inline-block;
    margin-right: 7px;
    vertical-align: top;

    &:first-child {
      margin-left: 14px;
    }
  }

  a {
    width: 186px;
    height: 105px;
    border-radius: 3px;
    background: #f5f5f5;
    padding: 11px 15px;
    box-sizing: border-box;
    display: flex;
    white-space: normal;
    flex-direction: column;
    justify-content: center;
    position: relative;

    &.more {
      width: 70px;
      text-align: center;
      line-height: 70px;
      font-size: 15px;
      color: #000;

      &:after {
        content: '';
        @extend %-vertical-center;
        right: 12px;
        @include arr(6px, 45deg, #555);
      }
    }
  }

  .tit {
    display: block;
    @include line-clip(2);
    font-size: 15px;
    color: #222;
    line-height: 22px;
    margin-bottom: 5px;
    font-weight: bold;
    overflow: hidden;
    text-overflow: ellipsis;
    word-wrap: normal;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    display: -webkit-box;
  }

  .con {
    display: block;
    @include line-clip(2);
    font-size: 13px;
    color: #000;
    line-height: 19px;
    overflow: hidden;
    text-overflow: ellipsis;
    word-wrap: normal;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    display: -webkit-box;
  }
}

.dt-episode-list {
  font-size: 0;

  li {
    display: inline-block;
    width: 18%;
    margin-right: 2.5%;
    margin-bottom: 2.5%;
    height: 50px;
    border-radius: 3px;
    background: #f5f5f5;
    font-size: 15px;
    position: relative;

    &:nth-child(5n) {
      margin-right: 0;
    }
  }

  a {
    color: #000;
    text-align: center;
    display: block;
    width: 100%;
    height: 100%;
    line-height: 50px;
  }
}
</style>
